export const state = () => ({
    collpase_sidebar: false,
    theme: 'theme-light',
    language: 'en',
    company_details: {},
});
export const getters = {
    getCollapseSidebar: (state: any) => state.collpase_sidebar,
    getTheme: (state: any) => state.theme,
    getLanguage: (state: any) => state.language,
    getCompanyDetails: (state: any) => state.company_details,
};
export const mutations = {
    setCollapseSidebar(state: any, payload: any) {
        state.collpase_sidebar = payload;
    },
    setTheme(state: any, payload: any) {
        state.theme = payload;
    },
    setLanguage(state: any, payload: any) {
        state.language = payload;
    },

    setCompanyDetails(state: any, payload: any) {
        state.company_details = payload;
    },
};
export const actions = {
    updateCollapseSidebar(state: any, payload: any) {
        state.commit('setCollapseSidebar', payload);
    },
    setTheme(state: any, payload: any) {
        state.commit('setTheme', payload);
    },
    setLanguage(state: any, payload: any) {
        state.commit('setLanguage', payload);
    },

    async getCompanyDetails(state: any, payload: any) {
        return new Promise((resolve, reject) => {
            this.$axios
                .get('/api/company/' + state.state.auth.user.company.uuid)
                .then((res) => {
                    state.commit('setCompanyDetails', res.data);
                    resolve(res.data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },

    async requestVerificationEmail() {
        return new Promise((resolve, reject) => {
            this.$axios
                .post('/email/verification-notification')
                .then((res) => {
                    resolve(res.status);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },

    async verifyEmail(state: any, payload: any) {
        return new Promise((resolve, reject) => {
            this.$axios
                .get(payload)
                .then((res) => {
                    resolve(res.status);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
};